import request from '@/network/http'

export function getCheckupSubjectList(data) {
    return request({
        url: 'Checkup/CheckupSubject/getCheckupSubjectList',
        method: 'post',
        data
    })
}

export function deleteCheckupSubjectInfo(data) {
    return request({
        url: 'Checkup/CheckupSubject/deleteCheckupSubjectInfo',
        method: 'post',
        data
    })
}

export function addCheckupSubjectInfo(data) {
    return request({
        url: 'Checkup/CheckupSubject/addCheckupSubjectInfo',
        method: 'post',
        data
    })
}

export function getOrganizationTypeList() {
    return request({
        url: 'Base/Organization/getOrganizationTypeList',
        method: 'post',
    })
}

export function getInvestigationLevelList(data) {
    return request({
        url: 'Base/Checkup/getInvestigationLevelList',
        method: 'post',
        data
    })
}

export function editCheckupSubjectInfo(data) {
    return request({
        url: 'Checkup/CheckupSubject/editCheckupSubjectInfo',
        method: 'post',
        data
    })
}

export function getCheckupItemInSubjectList(data) {
    return request({
        url: 'Checkup/CheckupSubject/getCheckupItemInSubjectList',
        method: 'post',
        data
    })
}

export function getCheckupSubjectDetail(data) {
    return request({
        url: 'Checkup/CheckupSubject/getCheckupSubjectDetail',
        method: 'post',
        data
    })
}

export function getCheckupItemList(data) {
    return request({
        url: 'Checkup/CheckupItem/getCheckupItemList',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/apis/checklistTemp.js